/**
* TickUtil.js
* 
* Created on 5-mrt-2015, 13:26:00
*
* @author Harm Boschloo for Ranj
**/

export default class TickUtil {
    static callOnNextTick(callback, argumentsToPass, scope) {
        const tickCallback = () => {
            createjs.Ticker.removeEventListener("tick", tickCallback);
            callback.call(scope, argumentsToPass);
        };

        createjs.Ticker.addEventListener("tick", tickCallback);
    }
}